document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Remove preload
	 */
	document.getElementsByTagName("BODY")[0].classList.remove('preload');

	/**
	 * IE support for object-fit
	 */
	objectFitImages();

});


$( ".menu" ).click(function() {
    event.preventDefault();
    $( ".mobile-nav" ).toggleClass("open");
	$( ".menu" ).toggleClass("opened");
    $( "body" ).toggleClass("nav-active");
});
